module.exports = __webpack_public_path__ + "img/alert-warn.2cb24442.svg";